import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { RecordField } from '@app/models/record.model';
import { Staff } from '@app/models/staff.model';
import { NoteTitleInputParams } from '@care-connect-japan/ckweblib/lib/data/schema/params/library-params';
import { DateService } from '@app/services/date.service';
import { LibService } from '@app/services/lib.service';

@Component({
  selector: 'app-record-field',
  templateUrl: './record-field.component.html',
  styleUrls: ['./record-field.component.scss'],
})
export class RecordFieldComponent implements OnInit {
  @Input() staffList!: Staff[];
  @Input() record!: RecordField;
  @Input() duplicate?: boolean;
  @Input() collapsed: boolean = false;
  @Output() formChange = new EventEmitter<FormGroup>();

  noteTitleParams!: NoteTitleInputParams;

  private _form!: FormGroup;
  @Input()
  get form(): FormGroup {
    return this._form;
  }
  set form(form: FormGroup) {
    this._form = form;

    if (this.odrstfcd && !this.odrstfcd.value && this.hasStaffList) {
      this.odrstfcd.setValue(this.staffList[0].stfcd);
    }
  }

  private _isDelete = false;
  @Input()
  get isDelete(): boolean {
    return this._isDelete;
  }
  set isDelete(isDelete: boolean) {
    this._isDelete = isDelete;
    if (isDelete) {
      this.disabled = true;
    }
  }

  private _disabled = false;
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(disabled: boolean) {
    this._disabled = disabled;
    if (disabled) {
      this.form.disable();
    }
  }

  constructor(
    private dateService: DateService,
    private libService: LibService,
  ) {
  }

  get summary() {
    return this.form.get('summary') as FormControl;
  }
  get handover() {
    return this.form.get('handover') as FormControl;
  }
  get startDate() {
    return this.form.get('startDate') as FormGroup;
  }
  get endDate() {
    return this.form.get('endDate') as FormGroup;
  }
  get caretime() {
    return this.form.get('caretime') as FormControl;
  }
  get odrstfcd() {
    return this.form.get('odrstfcd') as FormControl;
  }

  get hasStaffList() {
    return !!this.staffList && this.staffList.length > 0;
  }

  async ngOnInit(): Promise<void> {
    this.noteTitleParams = await this.libService.getNoteTitleParams(this.record, {
      duplicate: this.duplicate,
      inactive: this.isDelete,
    });
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }

  onCaretimeChange(): void {
    const startDate = this.dateService.parseFormToDate(this.startDate);
    if (!startDate) return;

    const caretime = parseInt(this.caretime.value);

    if (!this.record.noteid || this.endDate.invalid || caretime > 0) {
      const date = this.dateService.getMinutesLater(startDate, caretime);
      this.endDate.setValue({
        date,
        time: this.dateService.format(date, 'HH:mm'),
      });
    }
  }

  compareDate(): void {
    const startDate = this.dateService.parseFormToDate(this.startDate);
    const endDate = this.dateService.parseFormToDate(this.endDate);

    if (!startDate || !endDate) return;

    if (startDate.getTime() > endDate.getTime()) {
      this.endDate.setErrors({ compareDate: true });
    }
  }
}
